"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _BreakpointContext = _interopRequireDefault(require("./BreakpointContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var withBreakpoints = function withBreakpoints(BaseComponent) {
  var baseFactory = /*#__PURE__*/React.createFactory(BaseComponent);
  var breakpointsFactory = /*#__PURE__*/React.createFactory(_BreakpointContext.default.Consumer);
  var WithBreakpoints = function WithBreakpoints(baseProps) {
    return breakpointsFactory({
      children: function children(props) {
        return baseFactory(Object.assign({}, baseProps, props));
      }
    });
  };
  if (process.env.NODE_ENV !== 'production') {
    return (0, _recompose.setDisplayName)((0, _recompose.wrapDisplayName)(BaseComponent, 'withBreakpoints'))(WithBreakpoints);
  }
  return React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(WithBreakpoints, Object.assign({}, props, {
      ref: ref
    }));
  });
};
var _default = exports.default = withBreakpoints;